import * as client from 'filestack-js';
import ReactFilestack from './ReactFilestack';

export default ReactFilestack;
export { client };
